import { Enum } from "../enum";
import { Record } from "../record";


export type EnumRef<T extends string | number = string | number> = Record<string, T>;


export namespace EnumRef
{
    export function define<T extends string | number>($enum: EnumRef<T>, name: string): EnumRef<T>;
    export function define<T extends string | number>($enum: any, name: string): EnumRef<T>
    {
        $enum[enumKey] = name;
        return $enum;
    }

    export function isEnumRef<T extends string | number = string | number>(value: any): value is EnumRef<T>
    {
        return !!value && !!value[enumKey];
    }

    export function getName($enum: EnumRef): string;
    export function getName($enum: any): string
    {
        return $enum[enumKey];
    }

    export const getKey = Enum.getKey;

    export const values = Enum.values;


    const enumKey = Symbol("Enum");
}

